import { render, staticRenderFns } from "./parentAffiliate.vue?vue&type=template&id=5ab881de&scoped=true"
import script from "./parentAffiliate.vue?vue&type=script&lang=js"
export * from "./parentAffiliate.vue?vue&type=script&lang=js"
import style0 from "./parentAffiliate.vue?vue&type=style&index=0&id=5ab881de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab881de",
  null
  
)

export default component.exports